import React from "react";

function HowToRem(){
    return(

        <div className="container">
            <div className="row">
                <div className="col-lg-12">

                <h1>How to remember what you read in books?</h1>

                       

                        <div class="article-text">
                                <p>Each of us is faced with the need to memorize the information we read. Sometimes it is easy to remember, and other times it takes a lot of time and effort. What is the best way to memorize what you have read? The methodology you will learn is not complicated, it includes three steps:</p>

                                <p><span style={{"color":"#800000"}}><em>Impressions<br />
                                Associations<br />
                                Repetition</em></span></p>

                                <p><br />
                                Let&#39;s look at each stage in detail.</p>
                                <p><strong>Impressions</strong><br />
                                        The best information to remember is the one that makes a strong impression. For example, if you read someone&#39;s biography, and you&#39;re struck by a fact of life of a famous person, you&#39;re sure to remember it for a long time. The point of the technique is to reinforce the impression, for better memorization. Pay attention to all the interesting, unusual facts, events, descriptions. Good helps to strengthen the impression - scrolling scenes in your head, you can even imagine yourself as the protagonist. This will help you remember better what you&#39;ve read.</p>

                                        <p><strong>Associations</strong><br />
                                        Associate what you&#39;ve read with something familiar and familiar. Dates are good to remember if they coincide with some significant numbers for you. Names can be tied to consonant words. Remembering new things is easier if you associate them with something familiar - this rule always works.</p>

                                        <p><strong>Repetition</strong><br />
                                        The more times you read the necessary information, the better you will remember. The method is old but effective. It is suitable for all types of information - from cooking recipes to scientific texts. It is not at all necessary to read a book repeatedly in its entirety. It is enough to re-read the necessary passages. Now we know how to learn to remember what we read - we reinforce impressions, relate it to something known, repeat it. What are your favorite ways to read books and memorize what you read? What techniques do you use to remember the information you need?</p>
                                            

                                </div>

                </div>

            </div>

        </div>

    )
}

export default HowToRem